<template>
    <div class="d-flex flex-column gap-3">
        <div
            v-if="orders.length > 0"
            v-for="order in orders"
            :key="order.id"
            class="card border-0 shadow rounded-4 overflow-hidden mb-0"
            @click="viewOrder(order)"
        >
            <div class="card-body p-2 d-flex align-items-center gap-3 cursor-pointer">
                <!-- Icon Box -->
                <div 
                    class="rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
                    style="width: 48px; height: 48px;"
                    :class="getIconClass(order)"
                >
                    <i :class="getServiceIcon(order)" style="font-size: 1.5rem;"></i>
                </div>

                <!-- Content -->
                <div class="flex-grow-1 overflow-hidden">
                    <h6 class="mb-1 fw-bold text-truncate text-dark">
                        {{ 
                            order?.services?.length > 0 ? 
                            order?.services?.map(service => service.name).join(', ') : 
                            (order?.order_items[0]?.service?.name || 'Service')
                        }}
                    </h6>
                    <div class="text-muted small text-truncate">
                        {{ order?.customer?.name }} <span class="mx-1">&middot;</span> {{ getDueDateText(order) }}
                    </div>
                     <div class="text-muted small text-truncate mt-1">
                        <i class="bi bi-geo-alt me-1"></i>{{ order.booking_address }}
                    </div>
                    <div v-if="getHandymanName(order)">
                        <span class="badge bg-light text-dark border fw-normal mt-1">{{ getHandymanName(order) }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Project Cards (similar style) -->
        <div
            v-if="projects.length > 0"
            v-for="project in projects"
            :key="'p-'+project.id"
            class="card border-0 shadow-sm rounded-4 overflow-hidden mb-0"
            @click="viewProject(project)"
        >
             <div class="card-body p-3 d-flex align-items-center gap-3 cursor-pointer">
                <div class="rounded-3 d-flex align-items-center justify-content-center flex-shrink-0 bg-primary bg-opacity-10 text-primary" style="width: 48px; height: 48px;">
                    <i class="bi bi-briefcase-fill" style="font-size: 1.5rem;"></i>
                </div>
                <div class="flex-grow-1 overflow-hidden">
                    <h6 class="mb-1 fw-bold text-truncate text-dark">{{ project.name }}</h6>
                    <div class="text-muted small text-truncate">
                        {{ project.customer_name }} <span class="mx-1">&middot;</span> {{ dataTimeFormat(project.users[0]?.work_date,"DD-MMM") }}
                    </div>
                </div>
             </div>
        </div>

        <!-- Empty State -->
        <div v-if="orders.length == 0 && projects.length == 0" class="card border-0 shadow-sm rounded-4 mb-0">
             <div class="card-body p-4 text-center text-muted">
                <i class="bi bi-calendar-check d-block mb-2" style="font-size: 2rem;"></i>
                No tasks for this period
            </div>
        </div>
    </div>
</template>

<script>
import { appMixin } from '../mixin/appMixin';
export default {
    name: "OrderCard",
    mixins: [appMixin],
    props: {
        orders: {
            type: Object,
            default: () => {}
        },
        projects: {
            type: Object,
            default: () => {}
        },
        tab: {
            type: String,
            default: ''
        }
    },
    computed: {
        user() {
            return this.$store.state.user;
        }
    },
    methods: {
        viewOrder(order) {
            window.location.href = "/handyman/orders/" + order.order_number.toLowerCase();
        },
        viewProject(project) {
             window.location.href = "/handyman/projects/" + project.id;
        },
        getGoogleMapsUrl(address) {
            window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`, '_blank');
        },
        getIconClass(order) {
            // Randomly assign a color class or based on service type
            const colors = ['bg-primary text-primary', 'bg-warning text-warning', 'bg-info text-info', 'bg-success text-success', 'bg-danger text-danger'];
            const index = (order.id || 0) % colors.length;
            return colors[index] + ' bg-opacity-10'; // soft background
        },
        getServiceIcon(order) {
           // Return bootstrap icon class based on service name if possible
           const serviceName = (order?.services?.length > 0 ? order.services[0].name : (order?.order_items[0]?.service?.name || '')).toLowerCase();
           if (serviceName.includes('electr')) return 'bi bi-lightning-charge-fill';
           if (serviceName.includes('plumb')) return 'bi bi-droplet-fill';
           if (serviceName.includes('paint')) return 'bi bi-paint-bucket';
           if (serviceName.includes('fix') || serviceName.includes('repair')) return 'bi bi-wrench-adjustable';
           if (serviceName.includes('inspect')) return 'bi bi-search';
           return 'bi bi-tools';
        },
        getDueDateText(order) {
             const date = this.moment(order.booking_date);
             const today = this.moment().startOf('day');
             const tomorrow = this.moment().add(1, 'days').startOf('day');
             
             if (date.isSame(today, 'day')) return 'Due Today';
             if (date.isSame(tomorrow, 'day')) return 'Due Tomorrow';
             return 'Due ' + date.format('DD MMM');
        },
        isHighPriority(order) {
             // Example logic: high priority if overdue or marked as emergency
             // For now, let's say overdue (passed booking date) is high priority
             const date = this.moment(order.booking_date);
             if (date.isBefore(this.moment(), 'day')) return true;
             return false;
        },
        getHandymanName(order) {
            if (order.handymans && order.handymans.length > 0) {
                 return order.handymans.map(h => h.name).join(', ');
            }
            return '';
        }
    }
}
</script>
